/* 比赛列表基础 matches 生成器 */
import { ref } from '@vue/composition-api'
import eventBus from '@ms/utils/event-bus.js'

// 从 list 中删除 eventId 对应的 event 比赛
const removeMatch = (list = [], eventId = '') => {
  const index = list.findIndex((x) => x.eventId === eventId)
  if (index > -1) {
    list.splice(index, 1)
  }
}

// 从联赛 leagueList 中删除 eventId 对应的 event 比赛
const removeLeagueMatch = (leagueList = [], eventId = '', tournamentId = '') => {
  const index = leagueList.findIndex((x) => x.tournamentId === tournamentId)
  if (index > -1) {
    const league = leagueList[index]
    removeMatch(league.events, eventId)

    if (league.events.length === 0) {
      leagueList.splice(index, 1)
    }
  }
}

// 生成比赛列表(时间顺序) store
const createStoreMatchesByTime = () => {
  // 比赛列表
  const matches = ref([])
  const matchMap = new Map()
  // 删除状态锁：通过推送可能需要同时删除多个
  let lock = false
  let matchEndObserver = false

  // reset
  const resetMatches = () => {
    matches.value = []
  }

  // set matches
  const setMatches = (events = []) => {
    matches.value = events
    matchMap.clear()
    events.forEach((x) => {
      matchMap.set(x.eventId, true)
    })

    if (!matchEndObserver && events.length) {
      matchEndObserver = true
      eventBus.$on('matchEnd', onMatchEnd)
    }
  }

  const onMatchEnd = (eventId = '') => {
    if (!eventId || !matchMap.has(eventId)) return
    if (!lock) {
      lock = true
      removeMatch(matches.value, eventId)
      matchMap.delete(eventId)
      lock = false
      if (matches.value.length === 0) {
        eventBus.$off('matchEnd', onMatchEnd)
        matchEndObserver = false
      }
    } else {
      setTimeout(() => {
        onMatchEnd(eventId)
      }, 0)
    }
  }

  return {
    matches,
    resetMatches,
    setMatches
  }
}

// 生成比赛列表(联赛顺序) store
const createStoreMatchesByLeague = () => {
  // 联赛列表, 含比赛
  const leagues = ref([])
  const leagueMap = new Map()
  // 删除状态锁：通过推送可能需要同时删除多个
  let lock = false
  let matchEndObserver = false

  // reset
  const resetLeagues = () => {
    leagues.value = []
  }

  // set leagues
  const setLeagues = (tournaments = []) => {
    leagues.value = tournaments
    tournaments.forEach((x) => {
      const matchMap = new Map()
      x.events.forEach((event) => {
        matchMap.set(event.eventId, true)
      })
      leagueMap.set(x.tournamentId, matchMap)
    })

    if (!matchEndObserver && tournaments.length) {
      matchEndObserver = true
      eventBus.$on('matchEnd', onMatchEnd)
    }
  }

  const onMatchEnd = (eventId = '', tournamentId = '') => {
    if (!eventId || !leagueMap.has(tournamentId) || !leagueMap.get(tournamentId).has(eventId)) return
    if (!lock) {
      lock = true
      const league = leagueMap.get(tournamentId)
      if (league) {
        removeLeagueMatch(leagues.value, eventId, tournamentId)
        league.delete(eventId)
        if (league.size === 0) {
          eventBus.$off('matchEnd', onMatchEnd)
          leagueMap.delete(tournamentId)
          matchEndObserver = false
        }
      }
      lock = false
    } else {
      setTimeout(() => {
        onMatchEnd(eventId, tournamentId)
      }, 0)
    }
  }

  return {
    leagues,
    resetLeagues,
    setLeagues
  }
}

export default function useCreateMatches(type = 'time') {
  // type: 'time', 'league'
  if (type === 'time') {
    return createStoreMatchesByTime()
  } else if (type === 'league') {
    return createStoreMatchesByLeague()
  }
}
